import { reduce } from 'lodash/fp';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';
import 'core-js/features/array';
import 'core-js/features/map';
import 'core-js/features/number/is-finite';
import 'error-polyfill';

if (FileReader.prototype.readAsBinaryString === undefined) {
  /* eslint-disable func-names */
  FileReader.prototype.readAsBinaryString = function (fileData) {
    /* eslint-enable */
    const reader = new FileReader();

    reader.onload = () => {
      const bytes = new Uint8Array(reader.result);

      this.content = reduce((acc, cur) => acc + String.fromCharCode(cur), '', bytes);

      this.onload();
    };
    reader.readAsArrayBuffer(fileData);
  };
}

if (!Intl.PluralRules) {
  Promise.all([
    import('@formatjs/intl-pluralrules/polyfill'),
    import('@formatjs/intl-pluralrules/dist/locale-data/en'),
    import('@formatjs/intl-pluralrules/dist/locale-data/ko'),
    import('@formatjs/intl-pluralrules/dist/locale-data/ja'),
    import('@formatjs/intl-pluralrules/dist/locale-data/zh'),
  ]);
}

if (!Intl.RelativeTimeFormat) {
  Promise.all([
    import('@formatjs/intl-relativetimeformat/polyfill'),
    import('@formatjs/intl-relativetimeformat/dist/locale-data/en'),
    import('@formatjs/intl-relativetimeformat/dist/locale-data/ko'),
    import('@formatjs/intl-relativetimeformat/dist/locale-data/ja'),
    import('@formatjs/intl-relativetimeformat/dist/locale-data/zh'),
  ]);
}
